import { render } from "./staff_cert.vue?vue&type=template&id=f4500e8c&scoped=true"
import script from "./staff_cert.vue?vue&type=script&lang=js"
export * from "./staff_cert.vue?vue&type=script&lang=js"

import "./staff_cert.vue?vue&type=style&index=0&id=f4500e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4500e8c"]])

export default __exports__